import { Inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'

/**
 * Admin Guard - Checks if user has 'admin' permission
 *
 * Used for protecting admin routes from unauthorized access.
 * Redirects to landing page if user doesn't have admin permission.
 */
@Injectable({
    providedIn: 'root'
})
export class AdminGuard  {

    constructor(
        @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
        @Inject(Router) private router: Router
    ) {}

    canActivate(
        // route: ActivatedRouteSnapshot,
        // state: RouterStateSnapshot
    ): boolean {
        // Admin is checked via isUserAdmin() method, not hasPermission('admin')
        // See: permissions.service.ts isTransitionPermitted() for reference
        const isAdmin = this.authContextStorageService.isUserAdmin()

        if (!isAdmin) {
            // Redirect to landing page if not admin
            this.router.navigate(['/landingPage'])
            return false
        }

        return true
    }
}
